import type { DraftSnapshot, RowState } from "./daily-entry.types";

function draftKey(workerId: string, workDate: string): string {
  return `normax-performance:daily-entry-draft:${workerId}:${workDate}`;
}

/**
 * Local-only draft recovery (DAILY_ENTRY_INTERACTION_SPEC.md §8.18/§9) — NOT a
 * background sync queue. Written every ~10s while there are unsaved changes;
 * read once on page load to offer "Vrati ih / Odbaci". Cleared after an
 * explicit, successful server save.
 */
export function saveDraftSnapshot(workerId: string, workDate: string, rows: RowState[]): void {
  const snapshot: DraftSnapshot = { workerId, workDate, rows, savedAt: new Date().toISOString() };
  try {
    window.localStorage.setItem(draftKey(workerId, workDate), JSON.stringify(snapshot));
  } catch {
    // localStorage unavailable/full — local recovery is best-effort, never blocks the UI.
  }
}

export function loadDraftSnapshot(workerId: string, workDate: string): DraftSnapshot | null {
  try {
    const raw = window.localStorage.getItem(draftKey(workerId, workDate));
    if (!raw) return null;
    return JSON.parse(raw) as DraftSnapshot;
  } catch {
    return null;
  }
}

export function clearDraftSnapshot(workerId: string, workDate: string): void {
  try {
    window.localStorage.removeItem(draftKey(workerId, workDate));
  } catch {
    // best-effort
  }
}
